export const PACKAGE_NAME = 'jiraFilterRefinement';
export const TEAM_NAME = 'empanada';
export const SOURCE_NAME = 'filterRefinement';

// Field JQL terms
export const ASSIGNEE = 'assignee';
export const ISSUE_KEY = 'issuekey';
export const TEXT_FIELDS = 'textfields';
